import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import GradientWrapper from '../GradientBox/GradientWrapper';
import { openAnimationTime } from '../globalUtils';
const defaultOpenDelay = 0.04;
const closeDelay = 0.06;
const openWait = 0.6;
// in sync with css
const closeDuration = 0.3;
const FixedElement = ({ idx, openDirection, allNum, allowOpen, firstPageOpen, fastOpenTransition, hasGradient, className, skipIntro, extraRevealDelay, openDelay = defaultOpenDelay, children, }) => {
    const [open, setOpen] = useState(false);
    const [showGradient, setShowGradient] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);
    const timeout = useRef(0);
    const gradientTimeout = useRef(0);
    const animateGradient = useRef(0);
    const sliderRef = useRef(null);
    const mounted = useRef(false);
    const allNumRef = useRef(allNum);
    allNumRef.current = allNum;
    const gradientElements = useRef([]);
    const openRef = useRef(open);
    openRef.current = open;
    const isIntroAnimation = useRef(false);
    const gradientElement = useRef(null);
    useEffect(() => {
        clearTimeout(gradientTimeout.current);
        if (open) {
            gradientElements.current = Array.from(sliderRef.current?.querySelectorAll('.gradient-wrapper') ?? []);
            setShowGradient(true);
        }
        else {
            setShowGradient(false);
            /* gradientTimeout.current = window.setTimeout(
              () => setShowGradient(false),
              closeDuration * 1000,
            ); */
        }
    }, [open]);
    useEffect(() => {
        if (allowOpen) {
            if (sliderRef.current && !open) {
                if (openDirection) {
                    if (openDirection === 'regular' && !skipIntro) {
                        sliderRef.current.style.transform = 'translateY(100px)';
                    }
                    if (openDirection === 'inverse' && !skipIntro) {
                        sliderRef.current.style.transform = 'translateY(-30px)';
                    }
                }
            }
            clearTimeout(timeout.current);
            if (openDirection) {
                timeout.current = window.setTimeout(() => setOpen(true), (firstPageOpen ? openWait * 1000 : 0) +
                    (extraRevealDelay ?? 0) * 1000 +
                    idx * openDelay * 1000 +
                    10);
            }
            else {
                timeout.current = window.setTimeout(() => setOpen(false), 10);
            }
        }
        mounted.current = true;
    }, [openDirection, allowOpen]);
    useEffect(() => {
        if (sliderRef.current) {
            if (open) {
                sliderRef.current.style.transition = '';
                setAnimation(true);
                clearTimeout(animateGradient.current);
                // TODO: keep it sync with CSS
                animateGradient.current = window.setTimeout(() => {
                    setAnimation(false);
                }, openAnimationTime);
                setTimeout(() => {
                    sliderRef.current.style.transform = 'translateY(0)';
                }, 0);
            }
            sliderRef.current.style.opacity = open ? '1' : '0';
        }
    }, [open]);
    const setAnimation = (state) => {
        isIntroAnimation.current = state;
        if (sliderRef.current) {
            if (state) {
                sliderRef.current.style.transition = fastOpenTransition
                    ? `opacity var(--openTranslate), transform var(--openTranslate)`
                    : `opacity var(--openTranslateLong), transform var(--openTranslateLong)`;
                if (gradientElement.current) {
                    gradientElement.current.style.opacity = '1';
                }
            }
        }
        setIsAnimating(state);
    };
    useEffect(() => {
        sliderRef.current?.parentElement?.addEventListener('animation', onAnimationUpdate);
        return () => {
            sliderRef.current?.parentElement?.removeEventListener('animation', onAnimationUpdate);
            gradientElement.current = null;
        };
    }, []);
    const onAnimationUpdate = (evt) => {
        if (isIntroAnimation.current)
            return;
        const pos = evt?.detail?.pos ?? 0;
        const fadeIdx = pos >= 0 ? idx : allNumRef.current - idx;
        const opacityFactor = (Math.abs(pos) / window.innerHeight) * (fadeIdx + 2);
        if (openRef.current) {
            if (sliderRef.current) {
                sliderRef.current.style.transition = 'none';
                sliderRef.current.style.opacity = Math.max(0, 1 - opacityFactor).toString();
                gradientElements.current?.forEach((element) => {
                    if (element) {
                        element.style.opacity = Math.max(0, 1 - opacityFactor * 3).toString();
                    }
                });
            }
        }
    };
    return (_jsxs("div", { className: `fixed-container-slide-element${className ? ` ${className}` : ''}${allowOpen ? ' allowed ' : ''}`, ref: sliderRef, children: [!!hasGradient && (_jsx(GradientWrapper, { active: showGradient, animating: isAnimating })), children] }));
};
export default FixedElement;
